import { render, staticRenderFns } from "./IndicatorPenalty.vue?vue&type=template&id=5f7a489e&scoped=true&"
import script from "./IndicatorPenalty.vue?vue&type=script&lang=js&"
export * from "./IndicatorPenalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a489e",
  null
  
)

export default component.exports